import { composeApplicantAddress } from './shareholderAddressFields';

export interface FlattenedAllotteeRow {
  contactCd: string;
  allotteeName: string;
  categoryCd: string;
  representativeName: string;
  representativeCd: string;
  idTypeCode: string;
  idTypeName: string;
  idNo: string;
  applicantAddress: string;
  currencyCode: string;
  currencyName: string;
  classCode: string;
  className: string;
  numberOfShares: string;
  amountPayable: string;
  paidUpShareCapital: string;
  certificateNo: string;
}

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export function flattenAllottees(input: {
  formData: Record<string, any>;
  eFilingDataValidation?: Record<string, any> | null;
}): FlattenedAllotteeRow[] {
  const formData = input.formData || {};
  const shareholders = Array.isArray(formData.shareholders) ? formData.shareholders : [];
  const list = Array.isArray(input.eFilingDataValidation?.ShareholderList)
    ? input.eFilingDataValidation?.ShareholderList
    : [];

  const byContact = new Map<string, any>();
  for (const s of list) {
    const cd = trim(s?.contactCd);
    if (cd && !byContact.has(cd)) byContact.set(cd, s);
  }

  const rows: FlattenedAllotteeRow[] = [];
  for (const sh of shareholders) {
    const contactCd = trim(sh?.shareholder);
    const seed = byContact.get(contactCd) || {};
    const allotteeName = trim(sh?.shareholderName) || trim(seed?.contactName) || trim(seed?.shareholderName);
    const currencies = Array.isArray(sh?.currencies) ? sh.currencies : [];
    for (const cur of currencies) {
      const shareClasses = Array.isArray(cur?.shareClasses) ? cur.shareClasses : [];
      for (const sc of shareClasses) {
        rows.push({
          contactCd,
          allotteeName,
          categoryCd: trim(sh?.categoryCd) || trim(seed?.categoryCd) || trim(seed?.category?.code),
          representativeName: trim(sh?.representativeName) || trim(seed?.representativeName),
          representativeCd: trim(sh?.representativeCd) || trim(seed?.representativeCd),
          idTypeCode: trim(sh?.idTypeCd) || trim(seed?.idType?.code),
          idTypeName: trim(sh?.idTypeName),
          idNo: trim(sh?.contactRegNo) || trim(seed?.uen),
          applicantAddress: composeApplicantAddress(sh || {}),
          currencyCode: trim(cur?.currency),
          currencyName: trim(cur?.currencyName) || trim(seed?.currency?.name) || trim(seed?.currencyName),
          classCode: trim(sc?.classOfShares),
          className: trim(sc?.classOfSharesName) || trim(seed?.classOfShares?.name),
          numberOfShares: trim(sc?.numberOfShares),
          amountPayable: trim(cur?.sharesPayable) || trim(seed?.sharesPayable),
          paidUpShareCapital:
            trim(sc?.paidUpShareCapital) || trim(seed?.paidUpShareCapital),
          certificateNo: trim(sc?.certificateNo) || trim(formData?.certificateNo) || trim(seed?.certiNo),
        });
      }
    }
  }

  return rows.filter((r) => r.allotteeName && r.currencyCode && r.classCode);
}

